module.exports = __webpack_public_path__ + "img/undraw_Code_review_re_woeb.869fc314.svg";